import { useQuery } from 'react-query';

import useWallets from '@hooks/useWallets';
import { QueryKey } from '@config/queryKey';
import { getQuery } from '@queries/queries';
import { useTectonicSdk } from '@providers/TectonicSdkProvider';

const useVaultDeposits = () => {
  const sdk = useTectonicSdk();
  const { currentAccount } = useWallets();

  const vaultDepositQuery = getQuery(QueryKey.TECTONIC_VAULT_DEPOSITS)(
    sdk,
    currentAccount ?? ''
  );
  const { data, isLoading } = useQuery(
    vaultDepositQuery.queryKey,
    vaultDepositQuery.queryFn,
    {
      refetchInterval: 10000,
      enabled: !!currentAccount && !!sdk,
    }
  );

  return { data, isLoading };
};

export default useVaultDeposits;
